// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._1bah1h6o{justify-content:center}\n._1bsb1w81{width:150px}\n._1e0c1txw{display:flex}\n._1tke53f4{min-height:75pt}\n._4cvr1h6o{align-items:center}\n._syazpnps{color:var(--ds-text-accent-blue,#05c)}", ""]);
// Exports
module.exports = exports;
